module.exports = "<div class=\"modal-header\">\r\n    <h4 class=\"modal-title\" style=\"font-size:16px;\"> Settings</h4>\r\n    <button type=\"button\" class=\"close\" (click)=\"activeModal.close()\" aria-label=\"Close\">\r\n        <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n</div>\r\n<div class=\"modal-body\">\r\n\r\n    <div>\r\n        <app-setting-list #settingList></app-setting-list>\r\n    </div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/setting/setting.component.html
// module id = ./src/app/components/setting/setting.component.html
// module chunks = main